import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { from, interval } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { LoaderService } from 'src/app/Services/loader.service';

import { CommonServices } from '../../../../../Services/common.service';
import { ExcelExportService } from './../../../../../Services/excel.service';
import { ActivatedRoute ,Router } from '@angular/router';
// const MY_DATE_FORMATS = {
//   parse: {
//     dateInput: 'DD-MM-YYYY',
//   },
//   display: {
//     dateInput: 'YYYY-MM-DD',
//     monthYearLabel: 'MMMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY'
//   },
// };



@Component({
  selector: 'app-over-speed-reports',
  templateUrl: './over-speed-reports.component.html',
  styleUrls: ['./over-speed-reports.component.css'],
  // providers: [
  //   { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  // ]
})
export class OverspeedReportsComponent implements OnInit {

  public formFilters: any = FormGroup;
  startDateError: boolean;
  public excelData = {};
  public enableAllOption: boolean = true;
  public multiSelectVehicle: boolean = false;
  public allVehDownload: boolean;
  public showPagination: boolean = true;
  public tableData = [];
  public alertsData = [];
  public cols = [
    { key: '#', display: '#' },
    { key: 'DateTime', display: 'Date / Time', headerConfig: { isDefault: true } },
    { key: 'Location', display: 'Location' },
    { key: 'Speed', display: 'Speed (km/h)', headerConfig: { isDefault: true } },

  ];
  public alertsCols = [
    { key: '#', display: '#' },
    {
      key: 'regNo', display: 'Reg no', config: {
        isVehicle: true,
      },
      headerConfig: { isDefault: true }
    },
    { key: 'formattedDate', display: 'Date / Time', headerConfig: { isDefault: true } },
    { key: 'speed', display: 'Speed' }
  ]
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };
  public noDataFoundEnable: boolean = false;
  public noDataEnable: boolean = false;

  public processedData: any = {};
  public objectKeys = Object.keys;
  public totalDistance: any = 0;
  public myDate = new Date();
  public maxDate: any;
  alertTabs: boolean = false;
  alertsObj = {};
  public button_type : string = "reports"
  constructor(
    public fb: FormBuilder,
    public comService: CommonServices,
    public api: ApiService,
    public loader: LoaderService,
    public excel: ExcelExportService,
    public router:ActivatedRoute
  ) {
    this.maxDate = new Date(
      this.myDate.getFullYear(),
      this.myDate.getMonth(),
      this.myDate.getDate() - 1
    );
    this.getRegNos();
    this.getVehicleDetails();
  }

  public showTable: boolean;
  public showTable2: boolean = false;
  public vehicleRegNos: any
  public vehicles = [
    {
      vehId: '436',
      trackerId: 39347,
      name: 'GS-TN-02-AH-0392',
      vehNumber: 'TN-02-AH-0392',
      driverName: '',
      driverPhnum: '',
      model: '',
      fuelCapacity: '',
      regenc: '64049418f416bec380a00cd14e49dacd'
    },
    {
      vehId: '430',
      trackerId: 20895,
      name: 'GS-TN-20-BT-4608',
      vehNumber: 'TN-20-BT-4608',
      driverName: '',
      driverPhnum: '',
      model: '',
      fuelCapacity: '',
      regenc: 'a8353f046c86454a9b9637d5cd68dfd5'
    },
    {
      vehId: '432',
      trackerId: 39434,
      name: 'GS-TN-02-AZ-7607',
      vehNumber: 'TN-02-AZ-7607',
      driverName: '',
      driverPhnum: '',
      model: 'Tata Ace ',
      fuelCapacity: '',
      regenc: '1ed6509c12dc1489a990938142bafb27'
    },
    {
      vehId: '437',
      trackerId: 39427,
      name: 'GS-TN-02-AP-8566',
      vehNumber: 'TN-02-AP-8566',
      driverName: '',
      driverPhnum: '',
      model: '',
      fuelCapacity: '',
      regenc: 'd3d12d0a0c87113a285e964b6a151266'
    },
    {
      vehId: '61950',
      trackerId: 39462,
      name: 'GS-TN02AZ7531',
      vehNumber: 'TN02AZ7531',
      driverName: '',
      driverPhnum: '',
      model: 'Tata Ace ',
      fuelCapacity: '',
      regenc: 'abedd0694944cdbdb910c2afbd452975'
    },
    {
      vehId: '438',
      trackerId: 8293,
      name: 'GS-TN-02-AH-6736',
      vehNumber: 'TN-02-AH-6736',
      driverName: '',
      driverPhnum: '',
      model: '',
      fuelCapacity: '',
      regenc: '87912c69b2a4b8ba4e4ac8ccf22f5451'
    },
    {
      vehId: '429',
      trackerId: 13793,
      name: 'GS-TN-02-AZ-7598',
      vehNumber: 'TN-02-AZ-7598',
      driverName: '',
      driverPhnum: '',
      model: '',
      fuelCapacity: '',
      regenc: 'bfc1f4198f69290a077bdc3be727e45b'
    },
    {
      vehId: '431',
      trackerId: 39431,
      name: 'GS-TN-02-AQ-5594',
      vehNumber: 'TN-02-AQ-5594',
      driverName: '',
      driverPhnum: '',
      model: '',
      fuelCapacity: '',
      regenc: '4f301518cfe51e581373d8443404545f'
    },
    {
      vehId: '434',
      trackerId: 39346,
      name: 'GS-TN-02-AF-5674',
      vehNumber: 'TN-02-AF-5674',
      driverName: '',
      driverPhnum: '',
      model: '',
      fuelCapacity: '',
      regenc: '7e57178ed25c6073c012817e4af952e0'
    },
    {
      vehId: '435',
      trackerId: 39348,
      name: 'GS-TN-02-AC-4115',
      vehNumber: 'TN-02-AC-4115',
      driverName: '',
      driverPhnum: '',
      model: '',
      fuelCapacity: '',
      regenc: '7918d0cf6edf8a78897efd1ee2144fcd'
    }
  ];

  async getVehicleEncryptRegNo(regNo) {
    return new Promise((resolve, rejects) => {
      this.api.getVehicleRegNo({ vehRegNo: regNo }).then((res) => {
        if (res['status'] == 'success') resolve(res['data']);
        else rejects(res['data'])
      })
    })
  }

  getVehicleDetails() {
    const obj = {
      orgID: localStorage.orgID,//this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
      vendorID: localStorage.vendorID //this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vehicles = res.data;


      }
    }).catch((err) => {
      console.log(err);
    });

  }

  getRegNos() {
    this.api.getOrgVehicleRegNos({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehicleRegNos = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  ngOnInit(): void {
    this.reactiveForm();
    // this.router.queryParams.subscribe(params =>{
    //   console.log("params['param1']",params['param1'])
    // })

  }

  reactiveForm() {
    this.formFilters = this.fb.group({
      selectedVehicle: ['', Validators.required],
      // singleDay : ['', Validators.required],
      sDate: ['', Validators.required],
      eDate: ['', Validators.required],
      speedLimit: ['', Validators.required],
    }, {
      validator: [this.comService.formToDateValidation('sDate', 'eDate', 'selectedVehicle')]
    });
  }



  async submitForm(obj: any) {
    try {
      console.log("submit call")
      let final_exceldata=[];
      let data_count=0;
      let process_count=0;
      let getdata_count=0;
      let processdata=0;
      let multiplevrhicles=[];
      this.processedData = {};
      let filterValues = obj.formFilds;
      // this.vehicles = obj.vehicles; //by rao
      this.allVehDownload = false;
      this.showTable = false;
      this.noDataFoundEnable = false;
      this.excelData = {};
      this.tableData = [];
      this.loader.show();
      const vehicle = filterValues.selectedVehicle;
      const startDate = new Date(filterValues.sDate + '');
      const endDate = new Date(new Date(new Date(filterValues.eDate).setHours(23, 59, 59)) + '');
      const arr: any[] = []
      const getDaysArray = function (start, end) {
        for (const dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
          const date = new Date(dt);
          arr.push(date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate()));
        }
        return arr;
      };
      const pad = (num) => {
        return num > 9 ? num : '0' + num;
      };
      const start = startDate.getFullYear() + '/' + pad(startDate.getMonth() + 1) + '/' + pad(startDate.getDate());
      const end = endDate.getFullYear() + '/' + pad(endDate.getMonth() + 1) + '/' + pad(endDate.getDate());
      const daylist: any = getDaysArray(new Date(start), new Date(end));
      const speed = filterValues.speedLimit;

      //let vehLen = []; 

      const vehLen = obj.formFilds.selectedVehicle === 'ALL'
          ? this.vehicles.filter((veh:any) => veh.vehRegNo).map((veh:any) => veh.vehRegNo).sort()
          : [obj.formFilds.selectedVehicle];

      
      // if (!Array.isArray(filterValues.selectedVehicle)) vehLen = [filterValues.selectedVehicle];
      // else vehLen = filterValues.selectedVehicle; //rao


      const checkCurrentDay = (date) => {
        var inputDate = new Date(date);
        // Get today's date
        var todaysDate = new Date();
        // call setHours to take the time out of the comparison
        if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) return true;
        else return false;
      };
      
      let vehRegString = '';
      for (let veh = 0; veh < vehLen.length; veh++) {
        if (vehLen[veh]) {
          if (vehRegString == '') vehRegString = vehLen[veh];
          else vehRegString = vehRegString + ',' + vehLen[veh];
        }
      }
     
      let vehRegEncryKey = await this.getVehicleEncryptRegNo(vehLen).catch((e) => { console.log('unable to veh reg no'); })

      let keys=Object.keys(vehRegEncryKey);
     
      
      for (let veh = 0; veh < vehLen.length; veh++) {

        let pdata: any = [], excel = [];
        if (vehLen[veh] != undefined) {
          if (this.processedData[vehLen[veh]] == undefined) { this.processedData[vehLen[veh]] = {}; }
         
          for (let day = 0; day < daylist.length; day++) {
            let checkDay = checkCurrentDay(daylist[day]);
            if (this.processedData[vehLen[veh]][daylist[day]] == undefined) this.processedData[vehLen[veh]][daylist[day]] = {};
            if (!checkDay) {
              this.loader.show(); //yy
              if (vehRegEncryKey[vehLen[veh]] != null) {
               
                const splitDate = daylist[day].split('/');
                const date = splitDate[2] + splitDate[1] + splitDate[0].slice(-2);
                const url = date + '/' + vehRegEncryKey[vehLen[veh]] + '.z';
                const res = await this.api.readS3Data(url).catch((e) => { });
                if (JSON.stringify(res) != '{}' && res != undefined && res != null && res != '') {

                  if (this.processedData[vehLen[veh]][daylist[day]] == undefined){ 
                    this.processedData[vehLen[veh]][daylist[day]] = {}; 
                }else{
                  console.log("4444444444");
                  process_count++;
                 processdata++;
                }
                  let tempData: any = await this.processData(res, speed);
                 
                  excel = [...excel, ...tempData['xldata']];
                  pdata = [...pdata, ...tempData['data']];
                  // console.log('P data ', pdata.data.length, pdata);
                    //this.loader.hide();//yy
                }
              }
            }
            else {
              //this.allVehDownload = false;
                this.loader.show(); //yy
              let obj = {
                vehRegNo: vehLen[veh],
                date: new Date().setHours(0, 0, 0)
              };
              if (this.processedData[vehLen[veh]][daylist[day]] == undefined) { this.processedData[vehLen[veh]][daylist[day]] = {}; }
              let getData = await this.comService.currentDayTrackingData(obj).catch((e) => { console.log('Unable to get current day data.'); });
              if(getData!==undefined){
                processdata++;
                getdata_count++;
                let tmpData: any = await this.processData(getData, speed);
                excel = [...excel, ...tmpData['xldata']];
                pdata = [...pdata, ...tmpData['data']];
              }
               // this.loader.hide();//yy
            }
            this.processedData[vehLen[veh]][daylist[day]] = pdata;
          }
          //console.log("Exceldata============",excel);
          //final_exceldata=[...final_exceldata,...excel];
          //excel=final_exceldata;
          if (excel.length > 0) {
            processdata++;
            data_count++;
            let sNo = 1;
            excel = excel.map((item) => {
              item['value'] = [sNo, ...item['value']];
              sNo++;
              return item;
            })

            let rowCount = 2;
            let endCell = 'E';
            let customizedData = [];
            let titleRow = {
              value: ['Overspeed Report'],
              font: {
                name: 'Corbel', family: 4, size: 16, bold: true,
                color: { argb: 'FFFFFFFF' },

              },
              mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
              alignment: {
                cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
              },
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '966462AF' },
                bgColor: { argb: '966462AF' }
              },
            }

            customizedData.push(titleRow);

            rowCount = rowCount + 4;

            let subtitleRow = {
              value: [
                // "Vehicle          : " + String(vehLen[veh]).toUpperCase() + "\n" +
                "Start Date     : " + this.comService.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
                "End Date       : " + this.comService.timestampToDate(new Date(endDate).getTime(), 'DMY') + "\n" +
                "Speed Limit   : " + speed + "",
              ],
              font: { name: 'Corbel', family: 4, size: 12 },
              mergeCells: `A${(rowCount - 3) + ''}:${endCell + rowCount + ''}`,
            }

            customizedData.push(subtitleRow);
            rowCount = rowCount + 1;
            let headerRow =
            {
              value: ['S No', 'Vehicle Reg No', 'Date / Time', 'Location', 'Speed'],
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF00' },
                bgColor: { argb: 'FF0000FF' }
              },
              font: { bold: true },
              border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            }
            customizedData.push(headerRow);
            customizedData.push(...excel);
            if (this.excelData[vehLen[veh].toUpperCase()] == undefined) { this.excelData[vehLen[veh].toUpperCase()] = {}; }

            this.excelData[vehLen[veh].toUpperCase()] = {
              customizedData: customizedData,
              data: {
                columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 25 }, { colNo: 3, width: 25 }, { colNo: 4, width: 70 },{ colNo: 5, width: 25 }]

              }
            };

            
          }
        }
      }
      if (vehicle != 'ALL') {
         this.loader.hide();
        this.tableData.sort(function (x, y) {
          return x.gpsts - y.gpsts;
        });
        this.showTable = true;

      } else {
       
        // console.log("data_count============",data_count,"getdata_count=======",getdata_count,"processdata======", processdata,"process_count=======",process_count);
        if(processdata==(data_count+getdata_count+process_count)){
          this.loader.hide();        
          this.allVehDownload = true; 
        }
       //by rao
      }
      this.noDataFoundEnable = true;
      // this.loader.hide();
    } catch (error) {
      console.log(error);
    }
  }

  processData(data: any, speed: any) {
    console.log("Process data========",speed)
    return new Promise((resolve, reject) => {
      try {
        const procesedData: any = [];
        const speedLimit = speed; // ((speed == undefined) || (speed == null) || (speed == '')) ? 5 : speed;
        const sortingData = {};
        if (data && data.length > 0) {
          data.map((item) => {
            item.date = this.comService.timestampToDate(item.gpsts, 'DMY H:M:S');
            if (item.date != undefined && parseInt(item.spd) > speedLimit) {
              sortingData[item.gpsts] = item;
            }
          });
        } else {
          //this.loader.show();
          this.noDataFoundEnable = true;
        }
        const objKeys = this.objectKeys(sortingData);
        if (objKeys && objKeys.length) {
          const tempEx = [];
          //console.log("sortingdata===========",sortingData);
          for (let i = 0; i < objKeys.length; i++) {
            const currentKey = objKeys[i];
            if ((sortingData[currentKey].spd != undefined) && (sortingData[currentKey].spd > speedLimit)) {
              console.log("ppppppppp=======",sortingData[currentKey].reg)
              const res = {
                VehicleRegno:sortingData[currentKey].reg,
                DateTime: sortingData[currentKey].date,
                Location: String(sortingData[currentKey].near).replace('\r', ''),
                Speed: sortingData[currentKey].spd,
              };
              const rowVal = {
                value: [sortingData[currentKey].reg,sortingData[currentKey].date, String(sortingData[currentKey].near).replace('\r', ''), sortingData[currentKey].spd]
              }
              //, this.totalDistance.toFixed(2)

              this.tableData.push(res);
              tempEx.push(rowVal);
            }

            if ((objKeys.length - 1) == i) {
              resolve({ data: this.tableData, xldata: tempEx });
            }
          }
        } else {
          resolve({ data: [], xldata: [] });
        }

      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  }
  async downloadAllVehicle() {
    const chunk: any = await this.comService.chunkObject(this.excelData, 50);

    for (let i = 0; i < chunk.length; i++) {
      //this.excel.generateExcel(chunk[i], 'Overspeed_Report_' + i + '_' + this.comService.timestampToDate(new Date().getTime(), 'DMY') + '.xlsx');
      this.excel.generateExcel(chunk[i], 'Overspeed_Report_'+ this.comService.timestampToDate(new Date().getTime(), 'DMY') + '.xlsx');
    }

  }
  downloadXL() {
    this.excel.generateExcel(this.excelData, 'Overspeed_Report_' +" " +this.comService.timestampToDate(new Date().getTime(), 'DMY') + '.xlsx');
  }
  alertFunction(event) {
    if(event == 'alerts'){
      this.button_type = 'alerts'
      this.alertTabs = true;
      this.tableData = [];
      this.excelData = [];
      this.noDataEnable = false;
      this.showTable = false;
    } 
    if(event == 'reports'){
      this.button_type = 'reports';
      this.alertTabs = false;
      this.alertsData = [];
      this.excelData = [];
      this.noDataFoundEnable = false;
    }

  }
  submitAlertForm(data) {
    let obj;
    let end_date:any;
    if(data['formFilds']['eDate'] && data['formFilds']['eDate']!=null){
      end_date= data['formFilds']['eDate'];
    }else{
      end_date=data['formFilds']['sDate'];
    }
    if (data['formFilds'] !== undefined) {
      console.log("Enddate====",data['formFilds']['eDate'])
      obj = {
        "vehicles": data['formFilds']['selectedVehicle'],
        "startDate": new Date(data['formFilds']['sDate']).getTime(),
        "endDate": new Date(end_date).getTime(),
        limit: 10,
        page: 1
      }
    } else {
      obj = data;
    }
    if (this.alertTabs) {
      this.alertsObj = obj;
    }
    this.api.transportOverSpeedAlerts(obj).then((res: any) => {
      if (res.status == "success") {
        this.alertsData = res?.data.map(alerts => {
          return {
            ...alerts,
            formattedDate: this.comService.timestampToDate(alerts["gpsTS"], 'DMY H:M:S')
          };
        });
        this.showTable2 = true;        
        this.processPagination(res, obj);
     if(this.alertsData.length == 0){
      this.noDataEnable = true;
     }
      }
    }).catch((error) => {
      console.log(error)
    })
  }
  pagination(data) {
    this.alertsObj['page'] = data['page'],
    this.alertsObj['limit'] = data['limit'];
    this.submitAlertForm(this.alertsObj)
  }
  processPagination(data, req) {
    this.showTable2 = false;
    this.paginationData = {
        page: req.page,
        limit: req.limit,
        totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.showTable2 = true;
}
getTotalCount(total, limit) {
  let result: any = 1;
  if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
  }
  return Math.floor(result);
}
}
